import { makeVar } from '@apollo/client'

/** Demo rounds the guest session holds per mode, read when the claim is offered. */
export interface GuestDemoRounds {
  upDownAi: number
  bullseye: number
}

export const EMPTY_GUEST_DEMO_ROUNDS: GuestDemoRounds = {
  upDownAi: 0,
  bullseye: 0
}

export const guestDemoRoundsVar = makeVar<GuestDemoRounds>(
  EMPTY_GUEST_DEMO_ROUNDS
)

/**
 * This visitor's guest session (FE-321), read or created once per page load
 * and shared by the analytics identity and the demo modes; `null` until then.
 */
export const guestSessionIdVar = makeVar<string | null>(null)

/**
 * The gateway refused to create a guest session (20 per IP per hour); not
 * retried in this page load.
 */
export const isGuestSessionRefusedVar = makeVar(false)
